import * as types from '../constants/drugstore_cart';
import localStorage from 'store';

let initialState = {
  items: localStorage.get('cart_items') || [],
  pharmacyOffers: [],
  isLoading: false,
  selectedOffer: null,
  orderCompleted: false,
  location: localStorage.get('cart_location') || {
    name: 'Киев',
    latitude: 50.4501,
    longitude: 30.5234,
  },
  mapCenter: localStorage.get('cart_location') || {
    latitude: 50.4501,
    longitude: 30.5234,
  },
  vErrors: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.ADD_TO_CART:
      return {
        ...state,
        items: payload,
      };
    case types.REMOVE_FROM_CART:
      return {
        ...state,
        items: payload,
      };
    case types.SET_CART_ITEM_COUNT:
      return {
        ...state,
        items: payload,
      };
    case types.FETCH_DRUGSTORES:
      return {
        ...state,
        isLoading: true,
        pharmacyOffers: [],
        selectedOffer: null,
      };
    case types.FETCH_DRUGSTORES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pharmacyOffers: payload,
      };
    case types.FETCH_DRUGSTORES_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case types.SELECT_OFFER:
      return {
        ...state,
        selectedOffer: payload,
      };
    case types.STORE_ORDER_SUCCESS:
      return {
        ...state,
        order: payload,
        selectedOffer: null,
        pharmacyOffers: [],
        isLoading: false,
        orderCompleted: true,
      };
    case types.STORE_ORDER_ERROR:
      return {
        ...state,
        isLoading: false,
      };

    case types.SET_V_ERRORS:
      return {
        ...state,
        vErrors: payload,
      };
    case types.FLUSH_ALL:
      return {
        ...state,
        selectedOffer: null,
        pharmacyOffers: [],
        items: [],
      };
    case types.SET_LOCATION:
      return {
        ...state,
        location: payload,
      };
    case types.SET_MAP_CENTER:
      return {
        ...state,
        mapCenter: payload,
      };
    case types.LOAD_MORE_OFFERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.LOAD_MORE_OFFERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pharmacyOffers: payload,
      };
    case types.LOAD_MORE_OFFERS_ERROR:
      return {
        ...state,
        isLoading: false,
      };

    case types.FLUSH_CONFIRM: {
      return {
        ...state,
        orderCompleted: false,
      };
    }
    case types.SET_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload,
      };
    default:
      return state;
  }
};
